export const PATIENT_TABLE_CONFIRMATION = {
  title: "Build patient tables?",
  body:
    "This brings the current schema's patient tables fully up to date — columns, " +
    "unique indexes, the id primary key, and the VitaID registry, generator and " +
    "trigger — then scans notes-c, groups visits by EHR ID or email, and inserts " +
    "the grouped records into patients_with_ehrid and patients_no_ehrid. " +
    "Existing grouped patients are left unchanged, and only this schema is touched.",
  confirmLabel: "Build patient tables",
  cancelLabel: "Cancel",
};

export const PATIENT_TABLE_EMPTY_CONFIRMATION = {
  title: "Create empty patient tables?",
  body:
    "This creates patients_with_ehrid and patients_no_ehrid — fully migrated, with " +
    "their security policies, primary key and VitaID trigger — for the current " +
    "schema WITHOUT importing anything from notes-c. You can then import a CSV into them.",
  confirmLabel: "Create empty tables",
  cancelLabel: "Cancel",
};

export const PATIENT_TABLE_PROGRESS_MESSAGES = [
  "Preparing patient table build...",
  "Checking target tables...",
  "Applying the patients_with_ehrid migration...",
  "Reading visits from notes-c...",
  "Grouping visits by EHR ID and email...",
  "Writing grouped patient records...",
  "Waiting for Supabase to finish the request...",
];

export const runPatientTableJob = async ({
  fetchImpl = fetch,
  backendUrl,
  schema = "public",
  empty = false,
  reset = false,
} = {}) => {
  if (!backendUrl) {
    throw new Error("Backend URL is required");
  }

  const response = await fetchImpl(`${backendUrl}/api/admin/patient-table/build/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    // `empty` = create structure only; `reset` = destructive "drop rows &
    // recreate from scratch" checkbox. Both default off.
    body: JSON.stringify({ schema, empty, reset }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || "Failed to build patient table");
  }

  return data;
};
